import { TFunction } from 'i18next';

import { _ } from '../third-party';
import {
  APIEntityType,
  APIOrder,
  APIProject,
  APITicket,
  APIUser,
  APIUserType,
} from '../types/api';
import { OrderFields } from '../utils/order';

export const SENSITIVE_FIELD_PLACEHOLDER = '﹡﹡﹡﹡﹡﹡' as const;

// projects

const PROJECT_SENSITIVE_FIELDS = [
  `address`,
  `deliveryAddress`,
  `longitude`,
  `latitude`,
];

export const projectHasSensitiveData = (
  project: APIProject,
  userType?: APIUserType,
) =>
  project &&
  (project.longitude === 0 ||
    // @ts-ignore
    project.longitude === SENSITIVE_FIELD_PLACEHOLDER) &&
  (project.latitude === 0 ||
    // @ts-ignore
    project.latitude === SENSITIVE_FIELD_PLACEHOLDER) &&
  userType === APIUserType.Support;

export const hideProjectSensitiveFields = (project: APIProject) => {
  const updatedData = { ...project };
  PROJECT_SENSITIVE_FIELDS.forEach((fieldPath) => {
    _.set(updatedData, fieldPath, SENSITIVE_FIELD_PLACEHOLDER);
  });
  return updatedData;
};

// orders

const ORDER_SENSITIVE_FIELDS = [
  OrderFields.DeliveryLocation,
  ...PROJECT_SENSITIVE_FIELDS.map(
    (fieldName) => `${OrderFields.Project}.${fieldName}`,
  ),
];

export const orderHasSensitiveData = (
  order: APIOrder,
  userType?: APIUserType,
) => order.volume === 0 && userType === APIUserType.Support;

export const hideOrderSensitiveFields = (order: APIOrder) => {
  const updatedData = { ...order };
  ORDER_SENSITIVE_FIELDS.forEach((fieldPath) => {
    _.set(updatedData, fieldPath, SENSITIVE_FIELD_PLACEHOLDER);
  });
  return updatedData;
};

// tickets

const TICKET_SENSITIVE_FIELDS = [
  'batchSize',
  'deliveryLocation',
  'totalOnDelivery',
];

export const ticketHasSensitiveData = (
  ticket: APITicket,
  userType?: APIUserType,
) =>
  (ticket.batchSize === 0 ||
    // @ts-ignore
    ticket.batchSize === SENSITIVE_FIELD_PLACEHOLDER) &&
  userType === APIUserType.Support;

export const hideTicketSensitiveFields = (ticket: APITicket) => {
  const updatedData = { ...ticket };
  TICKET_SENSITIVE_FIELDS.forEach((fieldPath) => {
    _.set(updatedData, fieldPath, SENSITIVE_FIELD_PLACEHOLDER);
  });
  return updatedData;
};

// users

const USER_SENSITIVE_FIELDS = ['phone', 'email'];

export const userHasSensitiveData = (user: APIUser, userType?: APIUserType) =>
  (user.email === null || user.email === SENSITIVE_FIELD_PLACEHOLDER) &&
  userType === APIUserType.Support;

export const hideUserSensitiveFields = (user: APIUser) => {
  const updatedData = { ...user };
  USER_SENSITIVE_FIELDS.forEach((fieldPath) => {
    _.set(updatedData, fieldPath, SENSITIVE_FIELD_PLACEHOLDER);
  });
  return updatedData;
};

export const getEntityTypeLabel = (
  entityType: APIEntityType | undefined | null,
  t: TFunction,
) => {
  if (!entityType) {
    return '';
  }
  return (
    {
      [APIEntityType.Order]: t('entityType.order.label'),
      [APIEntityType.Project]: t('entityType.project.label'),
      [APIEntityType.TeamUser]: t('entityType.user.label'),
      [APIEntityType.Ticket]: t('entityType.ticket.label'),
      [APIEntityType.Truck]: t('entityType.truck.label'),
      [APIEntityType.UserManagement]: t('entityType.userManagment.label'),
    }[entityType] || ''
  );
};
